export const useFonts = () => {
    return { isLoading: false };
}